import { sagaCreator } from '@adrias-online/steiner';

import helper from 'helpers/steinerHelper';

import { actions, actionTypes } from '../actions/portaliPagineOfferte';
import { selectors, DEFAULT_STATE } from '../reducers/portaliPagineOfferte';
import api from '../apis/portaliPagineOfferte';

const sagas = helper.createSagas(
    'portaliPagineOfferte',
    actionTypes,
    actions,
    api,
    selectors,
    DEFAULT_STATE,
    {
        resourceLabel: 'Pagina Offerta',
    }
);

const defaultSagas = sagaCreator.bootSagas(sagas, actionTypes);

export default [...defaultSagas];
